import { FaHandsHelping, FaUserMd, FaShieldAlt, FaHeart, FaAward, FaUsers } from 'react-icons/fa';

const About = () => {
  const values = [
    {
      icon: <FaHandsHelping className="text-3xl" />,
      title: 'Compassion',
      description: 'We treat every patient with empathy and understanding.',
    },
    {
      icon: <FaUserMd className="text-3xl" />,
      title: 'Professionalism',
      description: 'Our staff consists of qualified and experienced Home Care professionals.',
    },
    {
      icon: <FaShieldAlt className="text-3xl" />,
      title: 'Safety',
      description: 'We adhere to the highest standards of medical safety and hygiene.',
    },
    {
      icon: <FaHeart className="text-3xl" />,
      title: 'Care',
      description: 'Personalized care plans tailored to individual needs.',
    },
    {
      icon: <FaAward className="text-3xl" />,
      title: 'Excellence',
      description: 'Commitment to delivering exceptional home care services.',
    },
    {
      icon: <FaUsers className="text-3xl" />,
      title: 'Community',
      description: 'Serving the Haridwar community with dedication.',
    },
  ];

/*   const teamMembers = [
    {
      name: 'Dr. Rajesh Verma',
      role: 'Medical Director',
      experience: '15+ years',
      qualification: 'MBBS, MD',
      image: 'https://via.placeholder.com/150',
    },
    {
      name: 'Nisha Sharma',
      role: 'Head Nurse',
      experience: '12+ years',
      qualification: 'B.Sc Nursing',
      image: 'https://via.placeholder.com/150',
    },
    {
      name: 'Amit Patel',
      role: 'Operations Manager',
      experience: '10+ years',
      qualification: 'MBA Home Care',
      image: 'https://via.placeholder.com/150',
    },
  ]; */

  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-poppins">
            About Lerito Home Care
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Providing compassionate and professional Home Care services to the Haridwar community since 2015.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                <FaHeart className="text-white text-xl" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 font-poppins">Our Mission</h2>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed">
              To deliver exceptional home Home Care services that improve the quality of life for 
              our patients, providing professional medical care with compassion and dignity in the 
              comfort of their homes. We aim to make quality Home Care accessible and affordable 
              for every family in Haridwar.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <FaAward className="text-white text-xl" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 font-poppins">Our Vision</h2>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed">
              To become Haridwar's most trusted home Home Care provider, recognized for our 
              commitment to excellence, innovation in service delivery, and unwavering dedication 
              to patient well-being. We envision a community where quality Home Care is just a 
              phone call away.
            </p>
          </div>
        </div>

        {/* Our Values */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12 font-poppins">
            Our Core Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="text-health-blue mb-4">{value.icon}</div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12 font-poppins">
            Why Choose Lerito Home Care?
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              {[
                {
                  title: 'Experienced Professionals',
                  description: 'Our team consists of certified doctors, nurses, and caregivers with extensive experience.',
                },
                {
                  title: '24/7 Availability',
                  description: 'Emergency services and support available round the clock.',
                },
                {
                  title: 'Personalized Care Plans',
                  description: 'Customized treatment plans based on individual patient needs.',
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-health-blue rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">{index + 1}</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-1">{item.title}</h3>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="space-y-6">
              {[
                {
                  title: 'Quality Assurance',
                  description: 'Regular quality checks and patient feedback systems.',
                },
                {
                  title: 'Affordable Pricing',
                  description: 'Transparent pricing with no hidden costs.',
                },
                {
                  title: 'Comprehensive Services',
                  description: 'From nursing care to medical equipment - all under one roof.',
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-health-green rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">{index + 4}</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-1">{item.title}</h3>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-health-blue to-health-green rounded-2xl p-12 text-white text-center">
          <h2 className="text-3xl font-bold mb-6 font-poppins">
            Ready to Experience Quality Home Care?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join hundreds of satisfied families who trust Lerito Home Care for their medical needs
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
            <a
              href="tel:+918266958207"
              className="bg-white text-health-blue px-8 py-4 rounded-full font-bold hover:bg-blue-50 transition-colors"
            >
              📞 Call Us Now
            </a>
            <a
              href="https://wa.me/918266958207"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-bold hover:bg-green-600 transition-colors"
            >
              💬 Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;